<script setup>
defineProps({
    level: {
        type: Number,
        required: true,
    },
    total: {
        type: Number,
        required: true,
    },
});
</script>
<template>
    <div class="header">
        <div class="level">
            <span class="label">Уровень:</span>
            <span class="value">{{ level }}</span>
        </div>
        <div class="progress">
            <span class="label"><svg width='32' height='32'><use href='#leaf'></use></svg></span>
            <span class="value">{{ total }}</span>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.header {
    width: 36.5rem;
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    @media (max-width: vars.$x480) {
        width: 100%;
    }
}

.level,
.progress {
    display: flex;
    align-items: center;
    gap: 5px;
    font-family: var(--second-family);
    font-weight: 700;
    font-size: 2.8rem;
    line-height: 110%;
    text-transform: uppercase;
    @media (max-width: vars.$x480) {
        font-size: 2rem;
    }
}

.label {
    color: var(--text-accent-2-100);
    svg {
        width: 3.2rem;
        height: 3.2rem;
        stroke: transparent;
        @media (max-width: vars.$x480) {
            width: 2rem;
            height: 2rem;
        }
    }
}

.value {
   color: var(--text-inverse-100);
}
</style>
